import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=9026758a&scoped=true&"
import script from "./course-card.vue?vue&type=script&lang=ts&"
export * from "./course-card.vue?vue&type=script&lang=ts&"
import style0 from "./course-card.vue?vue&type=style&index=0&id=9026758a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9026758a",
  null
  
)

export default component.exports